var _path, _circle, _circle2, _path2, _path3, _rect, _rect2, _path4, _path5, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalSetupBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 127,
    viewBox: "0 0 30 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.5L14.5 126.5",
    stroke: "#222F64",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 33,
    r: 14.5,
    fill: "#222F64",
    stroke: "#222F64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 95,
    r: 14.5,
    fill: "white",
    stroke: "#767BA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37V29C23.9996 28.6493 23.9071 28.3048 23.7315 28.0012C23.556 27.6975 23.3037 27.4454 23 27.27L16 23.27C15.696 23.0945 15.3511 23.0021 15 23.0021C14.6489 23.0021 14.304 23.0945 14 23.27L7 27.27C6.69626 27.4454 6.44398 27.6975 6.26846 28.0012C6.09294 28.3048 6.00036 28.6493 6 29V37C6.00036 37.3507 6.09294 37.6952 6.26846 37.9988C6.44398 38.3025 6.69626 38.5547 7 38.73L14 42.73C14.304 42.9055 14.6489 42.998 15 42.998C15.3511 42.998 15.696 42.9055 16 42.73L23 38.73C23.3037 38.5547 23.556 38.3025 23.7315 37.9988C23.9071 37.6952 23.9996 37.3507 24 37Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43.08V33",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.2002,
    y: 28,
    width: 10.0292,
    height: 4.40031,
    transform: "rotate(30 6.2002 28)",
    fill: "#222F64",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.1533,
    height: 4.40031,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 23.7925 28.0786)",
    fill: "#222F64",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99V91C23.9996 90.6493 23.9071 90.3048 23.7315 90.0012C23.556 89.6975 23.3037 89.4454 23 89.27L16 85.27C15.696 85.0945 15.3511 85.0021 15 85.0021C14.6489 85.0021 14.304 85.0945 14 85.27L7 89.27C6.69626 89.4454 6.44398 89.6975 6.26846 90.0012C6.09294 90.3048 6.00036 90.6493 6 91V99C6.00036 99.3507 6.09294 99.6952 6.26846 99.9989C6.44398 100.303 6.69626 100.555 7 100.73L14 104.73C14.304 104.906 14.6489 104.998 15 104.998C15.3511 104.998 15.696 104.906 16 104.73L23 100.73C23.3037 100.555 23.556 100.303 23.7315 99.9989C23.9071 99.6952 23.9996 99.3507 24 99Z",
    stroke: "#767BA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 105.08V95",
    stroke: "#767BA7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.2002,
    y: 90,
    width: 10.0292,
    height: 4.40031,
    transform: "rotate(30 6.2002 90)",
    fill: "white",
    stroke: "#767BA7",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.1533,
    height: 4.40031,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 23.7925 90.0786)",
    fill: "white",
    stroke: "#767BA7",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSetupBoxes);
export default __webpack_public_path__ + "static/media/modal-setup-boxes.f887023d4843e2fc369eea6bbcabf1dc.svg";
export { ForwardRef as ReactComponent };